"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var axios_1 = __importDefault(require("axios"));
var axios_retry_1 = __importStar(require("axios-retry"));
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var generic_pool_1 = __importDefault(require("generic-pool"));
var json_bignumber_1 = __importDefault(require("@ledgerhq/json-bignumber"));
var eventemitter_1 = __importDefault(require("../utils/eventemitter"));
var network_1 = require("../../../../network");
var BitcoinLikeExplorer = /** @class */ (function (_super) {
    __extends(BitcoinLikeExplorer, _super);
    function BitcoinLikeExplorer(_a) {
        var explorerURI = _a.explorerURI, explorerVersion = _a.explorerVersion, disableBatchSize = _a.disableBatchSize;
        var _this = _super.call(this) || this;
        _this.disableBatchSize = false;
        var clientParams = {
            baseURL: explorerURI
        };
        // not react native
        if (!(typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
            // eslint-disable-next-line global-require,@typescript-eslint/no-var-requires
            var https = require("https");
            // uses max 20 keep alive request in parallel
            clientParams.httpsAgent = new https.Agent({
                keepAlive: true,
                maxSockets: 20
            });
        }
        var client = axios_1["default"].create(clientParams);
        _this.underlyingClient = client;
        // 3 retries per request
        (0, axios_retry_1["default"])(client, {
            retries: 3,
            retryCondition: function (e) {
                return (0, axios_retry_1.isNetworkOrIdempotentRequestError)(e) ||
                    // workaround for explorers v3 that sometimes returns 4xx instead of 5xx
                    (e.code !== "ECONNABORTED" &&
                        (!e.response ||
                            (e.response.status >= 400 && e.response.status <= 499)));
            }
        });
        // max 20 requests
        _this.client = generic_pool_1["default"].createPool({
            create: function () { return Promise.resolve({ client: client }); },
            destroy: function () { return Promise.resolve(); }
        }, { max: 20 });
        _this.explorerVersion = explorerVersion;
        if (disableBatchSize) {
            _this.disableBatchSize = disableBatchSize;
        }
        // Logging
        client.interceptors.request.use(network_1.requestInterceptor);
        client.interceptors.response.use(network_1.responseInterceptor, network_1.errorInterceptor);
        return _this;
    }
    BitcoinLikeExplorer.prototype.broadcast = function (tx) {
        return __awaiter(this, void 0, void 0, function () {
            var url, client, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/transactions/send";
                        return [4 /*yield*/, this.client.acquire()];
                    case 1:
                        client = _a.sent();
                        return [4 /*yield*/, client.client.post(url, { tx: tx })];
                    case 2:
                        res = _a.sent();
                        return [4 /*yield*/, this.client.release(client)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    BitcoinLikeExplorer.prototype.getTxHex = function (txId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, client, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/transactions/".concat(txId, "/hex");
                        this.emit("fetching-transaction-tx", { url: url, txId: txId });
                        return [4 /*yield*/, this.client.acquire()];
                    case 1:
                        client = _a.sent();
                        return [4 /*yield*/, client.client.get(url)];
                    case 2:
                        res = (_a.sent()).data;
                        return [4 /*yield*/, this.client.release(client)];
                    case 3:
                        _a.sent();
                        this.emit("fetched-transaction-tx", { url: url, tx: res[0] });
                        return [2 /*return*/, res[0].hex];
                }
            });
        });
    };
    BitcoinLikeExplorer.prototype.getCurrentBlock = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, client, res, block;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/blocks/current";
                        this.emit("fetching-block", { url: url });
                        return [4 /*yield*/, this.client.acquire()];
                    case 1:
                        client = _a.sent();
                        return [4 /*yield*/, client.client.get(url)];
                    case 2:
                        res = (_a.sent()).data;
                        return [4 /*yield*/, this.client.release(client)];
                    case 3:
                        _a.sent();
                        this.emit("fetched-block", { url: url, block: res });
                        if (!res) {
                            return [2 /*return*/, null];
                        }
                        block = {
                            height: res.height,
                            hash: res.hash,
                            time: res.time
                        };
                        return [2 /*return*/, block];
                }
            });
        });
    };
    BitcoinLikeExplorer.prototype.getBlockByHeight = function (height) {
        return __awaiter(this, void 0, void 0, function () {
            var url, client, res, block;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/blocks/".concat(height);
                        this.emit("fetching-block", { url: url, height: height });
                        return [4 /*yield*/, this.client.acquire()];
                    case 1:
                        client = _a.sent();
                        return [4 /*yield*/, client.client.get(url)];
                    case 2:
                        res = (_a.sent()).data;
                        return [4 /*yield*/, this.client.release(client)];
                    case 3:
                        _a.sent();
                        this.emit("fetched-block", { url: url, block: res[0] });
                        if (!res[0]) {
                            return [2 /*return*/, null];
                        }
                        block = {
                            height: res[0].height,
                            hash: res[0].hash,
                            time: res[0].time
                        };
                        return [2 /*return*/, block];
                }
            });
        });
    };
    BitcoinLikeExplorer.prototype.getFees = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, client, fees;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/fees";
                        this.emit("fetching-fees", { url: url });
                        return [4 /*yield*/, this.client.acquire()];
                    case 1:
                        client = _a.sent();
                        return [4 /*yield*/, client.client.get(url)];
                    case 2:
                        fees = (_a.sent()).data;
                        return [4 /*yield*/, this.client.release(client)];
                    case 3:
                        _a.sent();
                        this.emit("fetching-fees", { url: url, fees: fees });
                        return [2 /*return*/, fees];
                }
            });
        });
    };
    BitcoinLikeExplorer.prototype.getRelayFee = function () {
        return __awaiter(this, void 0, void 0, function () {
            var client, fees;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.acquire()];
                    case 1:
                        client = _a.sent();
                        return [4 /*yield*/, client.client.get("/network")];
                    case 2:
                        fees = (_a.sent()).data;
                        return [4 /*yield*/, this.client.release(client)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, parseFloat(fees["relay_fee"])];
                }
            });
        });
    };
    BitcoinLikeExplorer.prototype.getPendings = function (address, nbMax) {
        return __awaiter(this, void 0, void 0, function () {
            var params, res, pendingsTxs;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = this.explorerVersion === "v2"
                            ? {
                                noToken: "true"
                            }
                            : {
                                no_token: "true"
                            };
                        if (!this.disableBatchSize) {
                            params.batch_size = nbMax || 1000;
                        }
                        return [4 /*yield*/, this.fetchTxs(address, params)];
                    case 1:
                        res = _a.sent();
                        pendingsTxs = res.txs.filter(function (tx) { return !tx.block; });
                        pendingsTxs.forEach(function (tx) { return _this.hydrateTx(address, tx); });
                        return [2 /*return*/, pendingsTxs];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    BitcoinLikeExplorer.prototype.fetchTxs = function (address, params) {
        return __awaiter(this, void 0, void 0, function () {
            var url, client, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/addresses/".concat(address.address, "/transactions");
                        this.emit("fetching-address-transaction", { url: url, params: params });
                        return [4 /*yield*/, this.client.acquire()];
                    case 1:
                        client = _a.sent();
                        return [4 /*yield*/, client.client.get(url, {
                                params: params,
                                // some altcoin may have outputs with values > MAX_SAFE_INTEGER
                                transformResponse: function (string) {
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    return json_bignumber_1["default"].parse(string, function (key, value) {
                                        if (bignumber_js_1["default"].isBigNumber(value)) {
                                            if (key === "value") {
                                                return value.toString();
                                            }
                                            return value.toNumber();
                                        }
                                        return value;
                                    });
                                }
                            })];
                    case 2:
                        res = (_a.sent()).data;
                        return [4 /*yield*/, this.client.release(client)];
                    case 3:
                        _a.sent();
                        this.emit("fetched-address-transaction", { url: url, params: params, res: res });
                        return [2 /*return*/, res];
                }
            });
        });
    };
    // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-explicit-any
    BitcoinLikeExplorer.prototype.hydrateTx = function (address, tx) {
        // no need to keep those as they change
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line no-param-reassign
        delete tx.confirmations;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        delete tx.id;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        delete tx.lock_time;
        // eslint-disable-next-line no-param-reassign
        tx.account = address.account;
        // eslint-disable-next-line no-param-reassign
        tx.index = address.index;
        // eslint-disable-next-line no-param-reassign
        tx.address = address.address;
        tx.inputs.forEach(function (input) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            delete input.txinwitness;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            delete input.script_signature;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            delete input.input_index;
        });
        tx.outputs.forEach(function (output) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            delete output.script_hex;
            // eslint-disable-next-line no-param-reassign
            output.output_hash = tx.hash;
            // eslint-disable-next-line no-param-reassign
            output.block_height = tx.block ? tx.block.height : null;
            // Definition of replaceable, per the standard: https://github.com/bitcoin/bips/blob/61ccc84930051e5b4a99926510d0db4a8475a4e6/bip-0125.mediawiki#summary
            output.rbf = tx.inputs[0] ? tx.inputs[0].sequence < 0xffffffff : false;
        });
    };
    BitcoinLikeExplorer.prototype.getAddressTxsSinceLastTxBlock = function (batchSize, address, lastTx) {
        return __awaiter(this, void 0, void 0, function () {
            var params, res, hydratedTxs;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = this.explorerVersion === "v2"
                            ? {
                                noToken: "true"
                            }
                            : {
                                no_token: "true"
                            };
                        if (!this.disableBatchSize) {
                            params.batch_size = batchSize;
                        }
                        if (lastTx) {
                            if (this.explorerVersion === "v2") {
                                params.blockHash = lastTx.block.hash;
                            }
                            else {
                                params.block_hash = lastTx.block.hash;
                            }
                        }
                        return [4 /*yield*/, this.fetchTxs(address, params)];
                    case 1:
                        res = _a.sent();
                        hydratedTxs = [];
                        // faster than mapping
                        res.txs.forEach(function (tx) {
                            _this.hydrateTx(address, tx);
                            hydratedTxs.push(tx);
                        });
                        return [2 /*return*/, hydratedTxs];
                }
            });
        });
    };
    return BitcoinLikeExplorer;
}(eventemitter_1["default"]));
exports["default"] = BitcoinLikeExplorer;
//# sourceMappingURL=index.js.map